export default {
	floorplan: 0,
	elevation: "",
	brick: "",
	brick_material: "",
	stucco: "",
	stone: "",
	siding: "",
	siding_type: "",
	trim: "",
	plan_file: "",
	comments: "",
	arc_options: "",
	garage_color: "",
	roof_color: "",
	accent_color: "",
	sqft: "",
	masonry_percent: "",
	roof_pitch: "",
	driveway_position: "",
}